import classNames from 'classnames';

import { css } from '@sorare/css';

import { MaskIcon } from '#src/atoms/ui/MaskIcon/index.tsx';

import cornerUrl from './assets/corner.svg';

const ALL_POSITIONS = [
  'top-left',
  'top-right',
  'bottom-right',
  'bottom-left',
] as const;

const TOP_POSITIONS = ['top-left', 'top-right'] as const;

const DEFAULT_CORNER_SIZE = 35;

const corner = css`
  position: absolute;
  z-index: 1;
  display: flex;

  &.top-left {
    top: 0;
    left: 0;
  }
  &.top-right {
    top: 0;
    right: 0;
    transform: rotate(90deg);
  }
  &.bottom-right {
    bottom: 0;
    right: 0;
    transform: rotate(180deg);
  }
  &.bottom-left {
    bottom: 0;
    left: 0;
    transform: rotate(270deg);
  }

  & .mask-icon > span {
    mask-size: 100% 100%;
    transition: background-color 0.3s ease;
  }
`;

type Props = {
  topOnly?: boolean;
  color?: string;
  colors?: [string, string, string, string];
  cornerSize?: number;
  className?: string;
};

export const FrameCorners = ({
  topOnly,
  cornerSize = DEFAULT_CORNER_SIZE,
  color = 'var(--c-squads-secondary)',
  colors,
  className,
}: Props) => {
  const positions = topOnly ? TOP_POSITIONS : ALL_POSITIONS;

  return (
    <>
      {positions.map((position, i) => (
        <div
          key={position}
          className={classNames(corner, position)}
          style={{ color: colors?.[i] ?? color }}
        >
          <MaskIcon
            url={cornerUrl}
            height={cornerSize}
            width={cornerSize}
            className={className}
          />
        </div>
      ))}
    </>
  );
};
